import { Map } from "immutable";
import { ModuleEvents } from "./Actions";

const initialState = Map({
  selectedScreen: "comp-report",
  selectedBatchId: null,
  compSummary: null,
  auditLog: [],
  contacts: [],
  compTypes: [],
  loading: false,
});

export const Reducer = (state = initialState, action) => {
  const { payload, type, error } = action;

  switch (type) {
    case ModuleEvents.SET_SELECTED_SCREEN: {
      return state.set("selectedScreen", payload);
    }

    case ModuleEvents.SET_SELECTED_BATCH: {
      return state.set("selectedBatchId", payload);
    }

    case ModuleEvents.FETCH_COMP_SUMMARY: {
      if (error || !payload) {
        return state.set("compSummary", null).set("loading", false);
      }
      return state.set("compSummary", payload).set("loading", false);
    }

    case ModuleEvents.FETCH_COMP_AUDIT_LOG: {
      if (error || !payload) {
        return state.set("auditLog", []).set("loading", false);
      }
      return state.set("auditLog", payload || []).set("loading", false);
    }

    case ModuleEvents.FETCH_CONTACTS: {
      if (error || !payload) {
        return state.set("contacts", []).set("loading", false);
      }
      return state.set("contacts", payload || []).set("loading", false);
    }

    case ModuleEvents.FETCH_COMP_TYPES: {
      if (error || !payload) {
        return state.set("compTypes", []).set("loading", false);
      }
      return state.set("compTypes", payload || []).set("loading", false);
    }

    default:
      return state;
  }
};

export default Reducer;
